import { Inject, Options, Vue } from "vue-property-decorator";
import ModalBox from "@/shared/components/modal-box/index.vue";
import LoadingIndicator from "@/shared/components/loading-indicator/index.vue";
import ErrorIndicator from "@/shared/components/error-indicator/index.vue";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import { AppInsights } from "@/trust-admin-app/appInsights";
import { EventEmitter } from "events";
import store from "@/trust-admin-app/store";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AddIndividualPracticeRequest, PracticeAtcs } from "@/shared/modules/typescript-trustapi-client/models";

@Options({
  components: {
    ModalBox,
    LoadingIndicator,
    ErrorIndicator,
  },
  mixins: [FormatDateTimeMixin]
})
export default class AddAppointedPracticeModal extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private ai = new AppInsights;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private searchText = '';
  private submitPressed = false;
  private searchPressed = false;
  private isSearching = false;
  private submitting = false;
  private practiceList: any[] = [];
  private selectedPracticeList: any[] = [];

  private totalResultCount = 0;
  private numResultsShowing = 0;
  private skip = 0;

  private closeModal(): void {
    this.$emit('close');
  }

  private isFormValid(): boolean {
    return this.selectedPracticeList != null && this.selectedPracticeList?.length > 0;
  }

  private async searchPractice(skip: number, take: 5, reset: boolean): Promise<void> {
    this.isSearching = true;
    this.searchPressed = true;
    if (reset) {
      this.practiceList = [];
      this.selectedPracticeList = [];
      this.skip = 0;
    }
    await this.apiService?.PracticeAtcsApi?.apiV2AtcsPracticeAdminSearchPracticeForExternalExaminerPost({
      skip: skip,
      take: take,
      keyword: this.searchText,
    })
      .then((res: any) => {
        res.data.data.forEach((element: any) => {
          this.practiceList.push(element);
        });
        this.totalResultCount = res.data.totalCount;
        this.numResultsShowing = this.practiceList.length;
        this.isSearching = false;
      })
      .catch((err: any) => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Error on searching practice: ' + err);
        this.isSearching = false;
      });

  }

  get displayShowMoreButton(): boolean {
    return this.totalResultCount > this.numResultsShowing;
  }

  private async submitButtonPressed(): Promise<void> {
    try {
      this.submitPressed = true;
      if (!this.isFormValid()) {
        throw ('Incomplete form - no Practice selected');
      }
      this.submitting = true;
      // Push selected practicesCoreID to array
      const practiceCoreIds: number[] = [];
      this.selectedPracticeList.forEach((element: any) => {
        practiceCoreIds.push(element.practiceCoreId);
      });

      const body: AddIndividualPracticeRequest = {
        practiceCoreIds: practiceCoreIds,
      }
      const ExternalExaminerId: number = parseInt(this.$route.query.eeId as string, 10);

      await this.apiService.PracticeAtcsApi?.apiV2AtcsPracticeAdminAddIndividualPracticeForExternalExaminerExternalExaminerIdPost(
        ExternalExaminerId,
        body
      );
      this.eventCtrl.emit('show-snackbar', 'success', 'Appoint Practice has been submitted');
      this.$emit('refresh');
      this.closeModal();
    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error submitting request: ' + err);
      this.ai.trackException('Error submitting request: ' + err);
    } finally {
      this.submitting = false;
    }
  }

  private updateSelected(p: PracticeAtcs) {
    // Search if practice is already in the list
    const index = this.selectedPracticeList.findIndex(x => x?.practiceCoreId === p.practiceCoreId);
    if (index > -1) {
      this.selectedPracticeList.splice(index, 1);
    } else {
      this.selectedPracticeList.push(p);
    }
  }

}

